<template>
  <v-container fluid>
    <v-row>
        <v-col>
          <v-card-title>
            <v-spacer></v-spacer>
            <v-btn  
              v-if="$route.name =='carpeta_personal'"
              rounded dark class="mr-4" color="info"
              :to="{name: 'documento', 'params': {'opt': 'create', 'from': 'carpeta'}}">
              <v-icon color="lighten-1">mdi-plus</v-icon>
              Cargar documento
            </v-btn>
            <v-btn  
              v-if="(($store.state.user.crear_expedientes && $route.name =='expedientes') || ($route.name =='carpeta_personal'))"
              rounded dark class="mr-4" color="primary"
              :to="{name: 'expediente_documento'}">
              <v-icon color="lighten-1">mdi-plus</v-icon>
              documento con flujo
            </v-btn>
            
          <v-btn  
          rounded dark class="mr-4" color="primary"
          @click="ver_carpeta_id()"
          >
          <v-icon color="lighten-1">mdi-plus</v-icon>
          Eliminar Carpeta
        </v-btn>
          
          </v-card-title>
          <DataTableServerSide opt="expedientes" :titulo="$store.state.user.expediente.nombre">
          </DataTableServerSide>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";


import DataTableServerSide from '@/components/DataTableServerSide.vue'; 
export default {
  components: { DataTableServerSide },
  data: function() {
    return {
    };
  },
  computed: {
    
  },
  watch: {
    
  },
  created () {

  },
  mounted() {
    //console.log(this.$route);
  },
  methods: {


    ver_carpeta_id(){

      let valores = window.location;
      let separacion_url = valores.pathname.split("/");
      console.log(separacion_url[2]);

      let paqueteData = { 
            "carpetaid": separacion_url[2], 
            "nombre": "ejemplo",
          }

          

          let carpeta_inactiva = axios.put('Carpeta/Inactivo', paqueteData,  { 'headers': this.$store.state.user.headers })
          return carpeta_inactiva
          .then((callback) => {
            if (callback.status == 201 || callback.status == 200) {
              let response = {
                expires_in: 7200,
                roles: this.$store.state.user.roles,
                info_firma: this.$store.state.user.info_firma,
                notificaciones_no_leidas:
                  this.$store.state.user.notificaciones_count,
                auth_token:
                  this.$store.state.user.headers.Authorization.replace(
                    "Bearer ",
                    ""
                  ),
              };
              this.$store
                .dispatch("MAIN_MENU", response)
                .then(({ status }) => {
                  this.padre_id = "";
                  this.selection = [];
                  this.$refs.form.reset();
                })
                .catch((errorMenu) => {
                  console.log("MAIN_MENU... error");
                });
              this.$store.dispatch("SHOW_ERROR", {
                show: true,
                type: "success",
                text: "Carpeta eliminada con exito!!",
              });
            }
            this.loading = false;
          })
          .catch((error) => {
            console.log(error.response);
            this.loading = false;
          });

        

     

      },
  },

};
</script>